import React, { useMemo } from "react";

import { SupDepositAlt, SupWithdrawAlt } from "@repo/core-ui";
import { useStoredData, useStoredDataDispatch } from "@/store/Context";
import { twMerge } from "tailwind-merge";

export default function Web3CommonCartSwitch() {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const currentCart = useMemo(() => {
    switch (storedData.overlay) {
      case "withdraw":
      case "deposit":
        return storedData.overlay;
      default:
        return undefined;
    }
  }, [storedData.overlay]);

  const handleWithdrawSwitch = () => storedData.overlay !== "withdraw" && storedDispatch({ type: "setOverlay", overlay: "withdraw" });

  const handleDepositSwitch = () => storedData.overlay !== "deposit" && storedDispatch({ type: "setOverlay", overlay: "deposit" });

  return (
    <div className="ml-auto flex h-full w-fit items-center">
      <button
        className={twMerge(
          "btn-icon cart-btn group relative h-[40px] w-[40px] justify-center border border-neutral-600 hover:bg-neutral-800 hover:text-neutral-75",
          currentCart === "deposit"
            ? "cursor-default bg-neutral-900 text-neutral-50 hover:bg-neutral-800 hover:text-neutral-75"
            : "border-r-[transparent]hover:bg-neutral-800 hover:text-neutral-75"
        )}
        onClick={handleDepositSwitch}
      >
        <span className="sr-only">Deposits</span>
        <SupDepositAlt />
        <span className="sup-badge cart-badge bg-primary-700 text-primary-25">{storedData.cart.length}</span>
      </button>
      <button
        className={twMerge(
          "btn-icon cart-btn group relative h-[40px] w-[40px] justify-center border border-l-0 border-neutral-600 hover:bg-neutral-200 hover:text-neutral-900",
          currentCart === "withdraw" && "active cursor-default bg-neutral-900 text-neutral-50 hover:bg-neutral-800 hover:text-neutral-75"
        )}
        onClick={handleWithdrawSwitch}
      >
        <span className="sr-only">Withdrawals</span>
        <SupWithdrawAlt />
        <span className="sup-badge cart-badge bg-primary-100 text-primary-900">{storedData.withdrawCart.length}</span>
      </button>
    </div>
  );
}
